<template>
	<div class="assoc-pill" @click="$emit('click')">
		<span class="assoc-pill__badge">{{ association.text_type }} {{ association.number }}</span>
		<span class="assoc-pill__title text-truncate">{{ association.title || association.name }}</span>
		<v-icon
			class="assoc-pill__close"
			small
			@click.stop="$emit('remove')"
		>mdi-close</v-icon>
	</div>
</template>

<script>
export default {
	name: 'AssociationPill',
	props: {
		association: {
			type: Object,
			required: true
		}
	}
}
</script>

<style scoped>
.assoc-pill {
	display: inline-flex;
	align-items: center;
	gap: 5px;
	padding: 3px 6px 3px 4px;
	border-radius: 20px;
	border: 1.5px solid #c5d3f8;
	background: #f0f4ff;
	cursor: pointer;
	max-width: 280px;
	transition: background 0.15s, border-color 0.15s, box-shadow 0.15s;
	font-size: 11px;
	line-height: 1.3;
}

.assoc-pill:hover {
	background: #e0e9ff;
	border-color: #5e85ef;
	box-shadow: 0 2px 6px rgba(94, 133, 239, 0.18);
}

.assoc-pill__badge {
	background: #5e85ef;
	color: #fff;
	border-radius: 12px;
	padding: 1px 7px;
	font-size: 10px;
	font-weight: 700;
	white-space: nowrap;
	flex-shrink: 0;
	letter-spacing: 0.2px;
}

.assoc-pill__title {
	color: #2d3a5c;
	font-weight: 500;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 160px;
}

.assoc-pill__close {
	color: #a0aec0 !important;
	flex-shrink: 0;
	transition: color 0.15s;
	font-size: 13px !important;
}

.assoc-pill__close:hover {
	color: #e53e3e !important;
}
</style>